import detailsActionTypes from "./details/actiontypes"
import listActionTypes from "./list/actiontypes"

export default {
  ...detailsActionTypes,
  ...listActionTypes,
}
